import styled from 'styled-components';
import { design } from 'utils';

export const TableCaption = styled.p`
  font-size: ${design.fontSizes[1]};
  margin: 0 0 ${design.spacing[2]} ${design.spacing[2]};
  color: ${design.colors.gray[8]};
`;
